import React, {} from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Example } from 'components';
import i18n from 'i18next';

const Container = styled.div`
	display: flex;
	flex-direction: column;
	align-items: stretch;
	gap: 20px;
`;

const ExmapleBlockHotel = () => {
	const { t } = useTranslation();

	return (
		<>

			<Container>

				<Example url={'https://images.acase.ru/sjas/xmlgw/xsd/HotelActionDescriptionRequest.xsd'} title={t('Схема запроса') + ' ' + t('Информация о гостинице')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/xsd/HotelActionDescriptionResponse.xsd'} title={t('Схема ответа') + ' ' + t('Информация о гостинице')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/xsd/HotelActionPublicListRequest.xsd'} title={t('Схема запроса') + ' ' + t('Список гостиниц')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/xsd/HotelActionPublicListResponse.xsd'} title={t('Схема ответа') + ' ' + t('Список гостиниц')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/xsd/HotelActionImageTypesRequest.xsd'} title={t('Схема запроса') + ' ' + t('Cписок категорий изображений')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/xsd/HotelActionImageTypesResponse.xsd'} title={t('Схема ответа') + ' ' + t('Cписок категорий изображений')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/sample/'+ i18n.language +'/HotelActionDescriptionRequest.xml'} title={t('Пример запроса') + ' ' + t('Информация о гостинице')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/sample/'+ i18n.language +'/HotelActionDescriptionResponse.xml'} title={t('Пример успешного ответа') + ' ' + t('Информация о гостинице')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/sample/'+ i18n.language +'/HotelActionPublicListRequest.xml'} title={t('Пример запроса') + ' ' + t('Список гостиниц')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/sample/'+ i18n.language +'/HotelActionPublicListResponse.xml'} title={t('Пример успешного ответа') + ' ' + t('Список гостиниц')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/sample/'+ i18n.language +'/HotelActionImageTypesRequest.xml'} title={t('Пример запроса') + ' ' + t('Cписок категорий изображений')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/sample/'+ i18n.language +'/HotelActionImageTypesResponse.xml'} title={t('Пример успешного ответа') + ' ' + t('Cписок категорий изображений')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/sample/'+ i18n.language +'/HotelActionDescriptionResponseError.xml'} title={t('Пример ответа с ошибкой')}/>

			</Container>
		</>
	);
};

export default ExmapleBlockHotel;